/**
 * Minimal semver comparison for the app-version gate (#4).
 * Compares the `x.y.z` core numerically, ignoring any `-prerelease` / `+build`
 * suffix. Missing segments count as 0 (`1.0` == `1.0.0`).
 *
 * Returns 1 if a > b, -1 if a < b, 0 if equal, or `null` if either version is
 * malformed (so callers can fail open rather than mis-gate the user).
 */
function parseCore(v: string): [number, number, number] | null {
  if (typeof v !== 'string' || v.trim() === '') return null;
  const core = v.trim().split('-')[0].split('+')[0];
  const parts = core.split('.');
  const nums: number[] = [];
  for (let i = 0; i < 3; i++) {
    const p = parts[i];
    if (p === undefined) {
      nums.push(0);
      continue;
    }
    if (!/^\d+$/.test(p)) return null;
    nums.push(parseInt(p, 10));
  }
  return nums as [number, number, number];
}

export function compareSemver(a: string, b: string): -1 | 0 | 1 | null {
  const pa = parseCore(a);
  const pb = parseCore(b);
  if (!pa || !pb) return null;
  for (let i = 0; i < 3; i++) {
    if (pa[i] > pb[i]) return 1;
    if (pa[i] < pb[i]) return -1;
  }
  return 0;
}
